// Angular dependencies
import { Injectable } from '@angular/core';

import { ApiService } from '../core/upgraded-providers';

export interface IResourcesPrice {
    [key: string]: any[];
}

const nw = window.nw;

@Injectable()
export class StoreService {
    constructor(
        private _apiService: ApiService
    ) {
    }

    async resources(): Promise<any> {
        let api = 'xsolla/store';
        if (nw) {
            api = 'steam/store';
        }

        try {
            const {
                lifetime,
                resources
            } = await this._apiService.get(api, { });

            return resources.reduce((acc, { resourceType, items }) => {
                items = items.sort(sort);

                return { ...acc, [resourceType]: items };
            }, { lifetime }) as IResourcesPrice;
        } catch (err) {
            throw err;
        }
    }
}

function sort(a, b) {
    if (a.amount < b.amount) {
        return -1;
    }

    if (a.amount > b.amount) {
        return 1;
    }

    return 0;
}
